import EditCreditMemoDrawer from './EditCreditMemoDrawer';

export const editCreditMemoDrawerRoute = {
  path: '#/credit-memo/:id',
  component: EditCreditMemoDrawer
};

export default editCreditMemoDrawerRoute;
